module.exports = __webpack_public_path__ + "static/media/buketixianyue xiao@2x.cefd0ec8.png";